export const blockIconsAudioandvideoShuffleNew = (
	<span className='material-symbols-outlined'>shuffle</span>
);
